export default {
  groupButton: {
    buy: 'MUA',
    sell: 'BÁN',
  },

  tabs: {
    balanceSheet: 'Cân Đối Kế Toán',
    incomeStatement: 'Kết Quả Kinh Doanh',
    cashFlowStatement: 'Lưu Chuyển Tiền Tệ',
  },
  timeTab: {
    quarterly: 'Theo Quý',
    yearly: 'Theo Năm',
  },
  bankTab: {
    nonBank: 'D.N Sản Xuất',
    bank: 'Ngân Hàng',
  },
  unitBillion: 'Tỷ',
  headerPDF: 'TỔNG QUAN DOANH NGHIỆP',
  footerText: 'FiinGroup Corporation',
  fiingroup: 'fiingroup.vn',
  notePDF:
    '<strong>*Miễn Giảm Trách Nhiệm:</strong> Nhà đầu tư cần lưu ý rằng các số liệu chính thức được công bố bởi doanh nghiệp thay vì FiinGroup. FiinGroup không đảm bảo tính chính xác của các kết quả dự phóng. Do đó, các kết quả này chỉ được sử dụng cho mục đích tham khảo. Vì vậy, FiinGroup không chấp nhận và chịu trách nhiệm cho bất cứ tổn thất nào của nhà đầu tư.',
  notePDFGroup2:
    'FIINGROUP CORPORATION</strong><br><strong>Trụ Sở :</strong>  Tầng 10, Tòa nhà PeakView, 36 Hoàng Cầu, Đống Đa, Hà Nội<br><strong>Chi nhánh Tp. Hồ Chí Minh:</strong> Tầng 3, Tòa nhà Profomilk Plaza , 51-53 Đường Võ Văn Tần, Quận 6, Thành phố Hồ Chí Mih<br>Email: fiingroup@fiingroup.vn',
  notePDFGroup3:
    'TRUNG TÂM CHĂM SÓC KHÁCH HÀNG </strong><br><strong>Hà Nội</strong> <br>Điện thoại: (8424) - 3562 6962 – Số máy lẻ: 103<br>Email: fiintrade@fiingroup.vn <br><strong>Thành phố Hồ Chí Minh </strong><br>Điện thoại: (8428) - 3933 3586 – Số máy lẻ: 201<br>Email: fiintrade@fiingroup',
  titleFinancialPerformanceYear:
    'BÁO CÁO TÀI CHÍNH: Dữ liệu tài chính của mã {0} trong 5 năm gần nhất ({1}-{2})',
  titleFinancialPerformanceQuater:
    'BÁO CÁO TÀI CHÍNH: Dữ liệu tài chính của mã {0} trong 5 quý gần nhất ({1}-{2})',
  titleFinancialPerformance: 'BÁO CÁO TÀI CHÍNH',
  unitPercentage: '%',
  formatCategory: "Q{0}'{1}",
  tableInfor: {
    unitMillion: 'Tr.',
    unitBillion: ' Tỷ',
    unitPercent: '%',
    foreignerRoom: 'Room Khối ngoại',
    stateHolding: 'SH Nhà nước (Tr.)',
    ForeignHoldings: 'SH Nước ngoài (Tr.)',
    MajorHoldings: 'Cổ đông lớn',
    ROE: 'ROE (%)',
    DE: 'D/E (lần)',
    YRange: 'Giá 1Y (Nghìn VND)',
    CEO: 'CEO',
    Competitors: 'Đối thủ',
    marketCap: 'Vốn hóa (Tỷ đồng)',
    AvgDailyVol: 'KLGDTB 10D',
    LastestDiv: 'Cổ tức (VND)',
    OutShare: 'CPLH (Triệu CP)',
    PE: 'P/E (lần)',
    PB: 'PB',
    EPS: 'EPS (VND)',
    EPSForward: 'EPS dự báo (VND)',
    FreeFloat: 'Free Float',
    StateHoldings: 'SH Nhà nước (Tr.)',
    ROA: 'ROA (%)',
    foreignHolding: 'SH Nước ngoài (Tr.)',
    totalForeignRoom: 'Tổng Room NN (Tr.)',
    foreignRoom: 'Room NN còn lại (Tr.)',
    freeFloat: 'FreeFloat (Tr.)',
  },
  chartTickerTooltip: {
    value: 'GTGD: ',
    volume: 'KLGD: ',
  },
  chartNonBank: {
    chartRevenue: {
      title: 'DOANH THU',
      yAxis1Title: 'Tỷ VND',
      yAxis2Title: 'Lần',
      tooltipNetSales: 'Doanh thu thuần {0}: {1} Tỷ.',
      tooltipAssetTurnover: 'Vòng quay TTS {0}: {1}',
      tooltipFixedAssetTurnover: 'Vòng quay TSCĐ {0}: {1}',
      legendNetSales: 'Doanh thu thuần',
      legendAssetTurnover: 'Vòng quay TTS',
      legendFixedAssetTurnover: 'Vòng quay TSCĐ',
    },
    chartProfit: {
      title: 'LỢI NHUẬN',
      yAxis1Title: 'Lãi Thuần (Tỷ VND)',
      yAxis2Title: 'Biên Lãi Thuần (%)',
      tooltipNetProfit: 'Lợi nhuận ròng {0}: {1} Tỷ.',
      tooltipGrossProfitMargin: 'Biên LN gộp {0}: {1} %',
      tooltipEBITMargin: 'Biên EBIT {0}: {1} %',
      tooltipNetProfitMargin: 'Biên LN ròng {0}: {1} %',
      legendNetProfit: 'Lợi nhuận ròng',
      legendGrossProfitMargin: 'Biên LN gộp',
      legendEBITMargin: 'Biên EBIT',
      legendNetProfitMargin: 'Biên LN ròng',
    },
    chartCashFlow: {
      title: 'LƯU CHUYỂN TIỀN TỆ',
      yAxis1Title: 'Tỷ VND',
      yAxis2Title: 'Phần Trăm',
      legendCFO: 'CFO',
      legendNCFF: 'CFF',
      legendNCFI: 'CFI',
      tooltipCFO: 'Dòng tiền hoạt động kinh doanh {0}: {1} Tỷ.',
      tooltipNCFF: 'Dòng tiền hoạt động tài chính {0}: {1} Tỷ.',
      tooltipNCFI: 'Dòng tiền hoạt dộng đầu tư {0}: {1} Tỷ.',
    },
    chartLiquidityRatio: {
      title: 'CHỈ SỐ THANH TOÁN(TTM)',
      yAxis1Title: 'Lần',
      tooltipCurrentRatio: 'Chỉ số thanh toán hiện thời {0}: {1}',
      tooltipQuickRatio: 'Chỉ số thanh toán nhanh {0}: {1}',
      tooltipCashRatio: 'Chỉ số tiền mặt {0}: {1}',
      legendCurrentRatio: 'Chỉ số thanh toán hiện thời ',
      legendQuickRatio: 'Chỉ số thanh toán nhanh ',
      legendCashRatio: 'Chỉ số tiền mặt ',
    },
    chartTotalAssset: {
      title: 'TỔNG TÀI SẢN',
      yAxis1Title: 'Tỷ VND',
      tooltipShortTermAsset: 'Tài sản Ngắn hạn {0}: {1} Tỷ',
      tooltipLongTermAsset: 'Tài sản Dài Hạn {0}: {1} Tỷ',
      legendShortTermAsset: 'Tài sản Ngắn hạn ',
      legendLongTermAsset: 'Tài sản Dài Hạn',
    },
    chartTotalLiability: {
      title: 'TỔNG NỢ',
      yAxis1Title: 'Tỷ VND',
      yAxis2Title: 'Phần Trăm',
      tooltipLiabilities: 'Nợ {0}: {1} Tỷ',
      tooltipEquityOwner: 'Vốn Chủ Sở Hữu {0}: {1} Tỷ',
      legendLiabilities: 'Nợ ',
      legendEquityOwner: 'Vốn Chủ Sở Hữu',
      legendCharterCapital: 'Vốn Điều Lệ ',
    },
    chartCapitalStructure: {
      title: 'CẤU TRÚC TÀI SẢN',
      yAxis1Title: 'Lần',
      tooltipDebt: 'Nợ/VCSH {0}: {1} lần',
      tooltipLTBorrwing: '(Vay NH+DH)/VCSH {0}: {1} lần',
      legendDebt: 'Nợ/VCSH',
      legendLTBorrwing: '(Vay NH+DH)/VCSH',
    },
    chartOperating: {
      title: 'CHỈ SỐ HOẠT ĐỘNG',
      yAxis1Title: 'Ngày',
      tooltipCashCycle: 'Chu kỳ tiền {0}: {1}',
      tooltipDaysSaleOutstanding: 'Số ngày phải thu {0}: {1}',
      tooltipDaysPayableOutstanding: 'Số ngày phải trả {0}: {1}',
      tooltipDaysInventoryOutstanding: 'Số ngày xử lý HTK {0}: {1}',
      legendCashCycle: 'Chu kỳ tiền',
      legendDaysSaleOutstanding: 'Số ngày phải thu',
      legendDaysPayableOutstandingOutstanding: 'Số ngày phải trả',
      legendDaysInventoryOutstanding: 'Số ngày xử lý HTK',
    },
    chartReturnOnCapital: {
      title: 'CHỈ SỐ SINH LỜI',
      yAxis1Title: 'Phần trăm (%)',
      tooltipROE: 'ROE {0}: {1} %',
      tooltipROIC: 'ROIC {0}: {1} %',
      legendROE: 'ROE',
      legendROIC: 'ROIC',
    },
    chartOperatingCashFlow: {
      title: 'DÒNG TIỀN KINH DOANH',
      yAxis1Title: 'Tỷ VND',
      tooltipCFO: 'CFO {0}: {1} Tỷ',
      tooltipReceivable: '{2} Phải thu {0}: {1} Tỷ',
      tooltipPayable: '{2} Phải trả {0}: {1} Tỷ',
      tooltipInventory: '{2} HTK {0}: {1} Tỷ',
      legendCFO: 'CFO',
      legendReceivable: '%{prefix} Phải thu',
      legendPayable: '%{prefix} Phải trả',
      legendInventory: '%{prefix} HTK',
    },
    chartDupont: {
      title: 'DUPONT',
      yAxis1Title: 'Phần trăm (%)',
      yAxis2Title: 'Lần',
      tooltipROE: 'ROE {0}: {1} %',
      tooltipNetProfitMargin: 'Biên LN ròng {0} TTM: {1} %',
      tooltipFinancialLeverage: 'Đòn bẩy tài chính {0}: {1}',
      tooltipAssetTurnover: 'Vòng quay TTS {0} TTM: {1}',
      legendROE: 'ROE',
      legendNetProfitMargin: 'Biên LN ròng TTM',
      legendFinancialLeverage: 'Đòn bẩy tài chính',
      legendAssetTurnover: 'Vòng quay TTS TTM',
    },
  },
  chartBank: {
    chartNetInterestIncome: {
      title: 'THU NHẬP LÃI THUẦN',
      yAxis1Title: 'NII (Thousand of Billion VND)',
      yAxis2Title: 'NIM (%)',
      tooltipNII: 'Thu Nhập Lãi Thuần {0}: {1} Tỷ',
      tooltipNIM: 'Tỷ lệ Thu Nhập Lãi Cận Biên{0}: {1}%',
      legendNII: 'Thu Nhập Lãi Thuần ',
      legendNIM: 'Tỷ lệ Thu Nhập Lãi Cận Biên ',
    },
    chartNetProfit: {
      title: 'LÃI THUẦN ',
      yAxis1Title: 'Nghìn Tỷ VND',
      yAxis2Title: 'Tăng trưởng (%)',
      tooltipNetProfit: 'Lãi Thuần {0}: {1} Tỷ',
      tooltipGrowth: 'Tăng Trưởng {0}: {1}%',
      legendNetProfit: 'Lãi Thuần',
      legendGrowth: 'Tăng Trưởng ',
    },
    chartBankTotalAsset: {
      title: 'TỔNG TÀI SẢN ',
      yAxis1Title: 'Nghìn Tỷ VND',
      yAxis2Title: 'Tăng trưởng(%)',
      legendTotalAsset: 'Tổng Tài Sản',
      legendGrowth: 'Tăng Trưởng',
      tooltipTotalAsset: 'Tổng Tài sản {0}: {1} Tỷ',
      tooltipGrowth: 'Tăng trưởng{0}: {1}%',
    },
    chartBadDebt: {
      title: 'NỢ XẤU(TTM)',
      yAxis1Title: 'Giá Trị(Nghìn Tỷ VND)',
      yAxis2Title: 'Tỷ lệ Nợ xấu (%)',
      tooltipBadDebtValue: 'Giá Trị {0}: {1} Tỷ',
      tooltipBadDebtRatio: 'Tỷ lệ Nợ xấu {0}: {1}%',
      legendBadDebtValue: 'Giá Trị',
      legendBadDebtRatio: 'Tỷ lệ Nợ xấu',
    },
    chartTotalCredit: {
      title: 'TÍN DỤNG',
      yAxis1Title: 'TC (Nghìn Tỷ VND)',
      yAxis2Title: 'Tăng Trưởng (%)',
      tooltipLoans: 'Tổng Tín Dụng {0}: {1} Tỷ',
      tooltipGrowth: 'Tăng Trưởng {0}: {1}%',
      legendLoans: 'Tổng Tín Dụng ',
      legendGrowth: 'Tăng Trưởng ',
    },
    chartTotalDeposit: {
      title: 'HUY ĐỘNG VỐN',
      yAxis1Title: 'TD (Nghìn Tỷ VND)',
      yAxis2Title: 'Tăng Trưởng (%)',
      tooltipDeposit: 'Tổng Huy Động {0}: {1} Tỷ',
      tooltipGrowth: 'Tăng Trưởng {0}: {1}%',
      legendDeposit: 'Tổng Huy Động ',
      legendGrowth: 'Tăng Trưởng',
    },
  },
};
